<template>
    <div v-if="isVisible" class="impersonation-banner">
        <i class="fal fa-user-secret" />
        <button type="button" @click="stop">
            Stop impersonating
        </button>
        <span class="impersonation-banner-name">{{ user.name }}</span>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import apiCall from '@/utils/apiCall';

export default {
    computed: {
        ...mapState(['user']),

        /**
         * Returns true when the current session is a Nova impersonation.
         *
         * @returns {boolean} Whether the banner is visible.
         */
        isVisible() {
            return null !== this.user && true === this.user.impersonated;
        },
    },

    methods: {
        /**
         * Stops the impersonation and returns to the admin panel.
         *
         * @returns {Promise<void>} Nothing.
         */
        async stop() {
            const { status, data } = await apiCall(this, 'post', '/api/user/impersonation/stop');

            if (200 === status) {
                window.location.href = data.redirect || '/admin';
            }
        },
    },
};
</script>
